import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FormFilesUpload,
  title: 'Files Upload',
  category: ComponentCategory.FormControls,
};
